export interface ProductContextMeshDeepLink {
    productId: number;
    contextMeshId: string;
    section: "console" | "files" | "integrations";
}

const PRODUCT_CONTEXT_MESH_PATH = /^\/products\/(\d+)\/context-meshes\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\/(files|integrations))?\/?$/i;

export function parseProductContextMeshDeepLink(pathname: string): ProductContextMeshDeepLink | null {
    const match = pathname.match(PRODUCT_CONTEXT_MESH_PATH);
    if (!match) return null;
    const productId = Number(match[1]);
    if (!Number.isSafeInteger(productId) || productId <= 0) return null;
    return {
        productId,
        contextMeshId: match[2].toLowerCase(),
        section: match[3] === "files" || match[3] === "integrations" ? match[3] : "console"
    };
}
